import React, { useCallback } from 'react';
import { isEmpty } from 'ramda';
import { SEOText, MetaTags, StaticMetaTags, FAQ } from '@corefront/seo-tools';
import CanonicalLink from './CanonicalLink/CanonicalLink';
import MetaRobots from './MetaRobots/MetaRobots';
import { withSEOContent } from '../../hocs/withSEOContent';
import {
  useMetaTagsRequestUrl,
  useStaticMetaTagsRequestUrl,
} from './hooks/useMetaTagsRequestUrl';
import { useSEOTextRequestUrl } from './hooks/useSEOTextRequestUrl';
import { useFAQRequestUrl } from './hooks/useFAQRequestUrl';
import { useSpecificPageLink } from './hooks/useSpecificPageLink';
import { useIsSSRMode } from '../../hooks/useIsSSRMode';
import { useTranslationMetaTags } from './hooks/useTranslationMetaTags';
import { useSEOTextFormat } from './hooks/useSEOTextFormat';
import { useMetaTagsFormat } from './hooks/useMetaTagsFormat';
import styles from './SEOWrapper.module.css';

const SEOWrapper = ({ children }) => {
  const isSSRMode = useIsSSRMode();
  const translate = useTranslationMetaTags();
  const formatSEOText = useSEOTextFormat();
  const formatMetaTags = useMetaTagsFormat();
  const specificPageLink = useSpecificPageLink();

  const staticMetaTagsRequestUrl = useStaticMetaTagsRequestUrl();
  const metaTagsRequestURL = useMetaTagsRequestUrl();
  const SEOTextRequestURL = useSEOTextRequestUrl();
  const FAQRequestURL = useFAQRequestUrl();

  const selectSpecificSEOData = useCallback(
    (data) => {
      if (!specificPageLink) return data;

      const specificSEOData = data.filter(
        (item) => item.pagelink.name === specificPageLink
      );

      if (isEmpty(specificSEOData)) {
        return data;
      }

      return specificSEOData;
    },
    [specificPageLink]
  );

  return (
    <>
      <StaticMetaTags
        translate={translate}
        requestUrl={staticMetaTagsRequestUrl}
        format={formatMetaTags}
      />
      <MetaTags
        requestUrl={metaTagsRequestURL}
        translate={translate}
        queryOptions={{
          select: selectSpecificSEOData,
        }}
        format={formatMetaTags}
      />
      <CanonicalLink />
      <MetaRobots />
      {children}
      <SEOText
        requestUrl={SEOTextRequestURL}
        collapsed={!isSSRMode}
        format={formatSEOText}
        queryOptions={{
          select: selectSpecificSEOData,
        }}
        className={styles['pm-casino-seo-content']}
      />
      <FAQ
        requestUrl={FAQRequestURL}
        collapsed={!isSSRMode}
        format={formatSEOText}
        queryOptions={{
          select: selectSpecificSEOData,
        }}
        className={styles['pm-casino-seo-content']}
      />
    </>
  );
};

export default withSEOContent(SEOWrapper);
